import React, { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext({ dirty: false, setDirty: () => {} });

export function UnsavedChangesProvider({ children }) {
  const [dirty, setDirty] = useState(false);
  return <Ctx.Provider value={{ dirty, setDirty }}>{children}</Ctx.Provider>;
}

export const useUnsaved = () => useContext(Ctx);

// Pages call this with their live "dirty" boolean to enable the internal-navigation guard.
export function useUnsavedGuard(isDirty) {
  const { setDirty } = useUnsaved();
  useEffect(() => { setDirty(!!isDirty); }, [isDirty, setDirty]);
  useEffect(() => () => setDirty(false), [setDirty]);
}
